export default __webpack_public_path__ + "static/media/214908.857e1965.jpg";